import BaseAPIService from '@/services/baseAPIService'

export default class DeveloperAPIService extends BaseAPIService {
  constructor(httpClient, reportingHttpClient) {
    super(httpClient, reportingHttpClient)
  }

  // Developer - To be removed in future / moved into system admin area
  developerGetSystemInfo()    { return this.httpClient.get('/developer/systeminfo') }
  developerGetReportingSystemInfo()    { return this.reportingHttpClient.get('/developer/systeminfo') }

  developerGetSystemLogList(params) {
    let queryString = $.param(params)
    return this.httpClient.get(`/developer/logs?${queryString}`)
  }
  developerGetJobQueueList()  { return this.httpClient.get('/developer/jobqueue') }
  developerGetOptimiserInfo(params) {
    let queryString = $.param(params)
    return this.httpClient.get(`/developer/optimiser?${queryString}`)
  }

  developerGetAutomationInfo(params) {
    let queryString = $.param(params)
    return this.httpClient.get(`/developer/automations?${queryString}`)
  }

  developerGetCacheInfo() {
    return this.httpClient.get(`/developer/cache`)
  }

  developerGetRecentActivityItemList() { return this.httpClient.get('/developer/activityitems') }

  developerOnboardNewAccount(data)    { return this.httpClient.post('/developer/onboarding/account', data) }

  developerProxyAccessAccount(data)   { return this.httpClient.post('/developer/proxy/login', data) }

  developerGetAccount(id)             { return this.httpClient.get(`/developer/accounts/${id}`) }
  developerGetBillingProducts()       { return this.httpClient.get(`/developer/billing/products`) }
  developerUpdateSubscription(accountId, subId, data) { return this.httpClient.put(`/developer/accounts/${accountId}/subscriptions/${subId}`, data) }
  developerCreateSubscription(accountId, data)        { return this.httpClient.post(`/developer/accounts/${accountId}/subscriptions`, data) }
  developerCreatePurchasedProduct(accountId, data)    { return this.httpClient.post(`/developer/accounts/${accountId}/products`, data) }

  developerCloseAccount(accountId)     { return this.httpClient.post(`/developer/accounts/${accountId}/close`) }
  developerReopenAccount(accountId)    { return this.httpClient.post(`/developer/accounts/${accountId}/reopen`) }

  developerGetMyobQuery(accountId, data) {
    return this.httpClient.post(`/developer/integrations/myob/accounts/${accountId}/search`, data)
  }
  developerGetXeroQuery(accountId, data) {
    return this.httpClient.post(`/developer/integrations/xero/accounts/${accountId}/search`, data)
  }
}
